import script from "./QuickStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickStatus.vue?vue&type=script&setup=true&lang=js"

import "./QuickStatus.vue?vue&type=style&index=0&id=0106cf22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0106cf22"]])

export default __exports__